import { formattedUrl } from '../utils/formattedUrl';

interface ILinks {
  login: string,
  api: string,
  adminApi: string,
  jobApi: string,
  pressReleases: string
}

export const baseUrls:ILinks = {
  login: formattedUrl('https://auth.cpgmedia.com', 'http://localhost:3105'),

  api: formattedUrl('https://api.bevnet.com', 'http://localhost:5003'),

  // Dev fallback matches `api` above: BevNET.API serves the same routes on both
  // https://localhost:5002 and http://localhost:5003, but the HTTPS listener uses a
  // self-signed cert, so every browser call from a dev server failed with an opaque
  // "Failed to fetch" until someone trusted it in their OS keychain. The apps all run
  // their dev servers over HTTP, so there is no mixed-content concern. Production is
  // unchanged — formattedUrl only returns this when NODE_ENV !== 'production'.
  jobApi: formattedUrl('https://api.bevnet.com', 'http://localhost:5003'),

  adminApi: formattedUrl('https://adminapi.bevnet.com', 'https://localhost:5001'),

  pressReleases: formattedUrl('https://submit.cpgmedia.com/news', 'http://localhost:3107/news')
};
